import React from 'react';
import HeaderSmall from '../Components/Header/HeaderUnauthorized';
import { hashHistory } from 'react-router'

class OutOfDatePage extends React.Component {

    returnFunction = () => {
        hashHistory.push('/?signout=true');
    }

    render() {
        return (
            <div>
                <HeaderSmall goBackFunction={this.returnFunction} >
                    <span className="white" >Services Unavailable</span>
                </HeaderSmall>
                <div className="container" >
                    <br />
                    <br />
                    <br />
                    <br />
                    <div style={{textAlign:'center', maxWidth:'90vw', margin:'0 auto'}}>
                        <span className="white" >Our records show that you are not currently enrolled in medical benefits.  If you believe you have received this message in error please contact support at: Support@medefy.com</span>
                    </div>
                </div>
            </div>
        );
    }
};

export default OutOfDatePage;


// WEBPACK FOOTER //
// ./src/Pages/OutOfDate.js